import { createSelector } from 'reselect';

import { orgIdSelector } from './orgIdSelector';

const settingsSelector = state => state.session.settings;

const getOrgName = (settings, orgId) => {
  const { userOrgs = [] } = settings;

  const orgName = userOrgs
    .find(elt => elt.id === orgId).name;

  return orgName;
};

export const orgNameSelector =
  createSelector([
    settingsSelector,
    orgIdSelector,
  ], getOrgName);
